                //##Global Variable is "WSAIO"
                //##This code will be executed after 2.5Sec of page load, if app is active or preview mode.
                window.wsaio_execute_custom_code = function ($) {
                    //alert("wsaio_execute_custom_code is working now!");

                    //         search discount custom code
                    // function search_variant_discount() {
                    //     if (WSAIO.template == 'search') {
                    //         $('.grid__item').each(function () {
                    //             var _this = $(this);
                    //             var handle = _this.find('.grid-view-item.product-card a').attr('href');
                    //             var vid = _this.find('.grid-view-item.product-card a').attr('href');
                    //             if (handle != undefined && handle != '#') {
                    //                 handle = handle.split("products/")[1];
                    //                 handle = handle.split("?")[0];
                    //                 vid = vid.split('variant=')[1];
                    //                 console.log(vid);
                    //                 $.getJSON("/products/" + handle + ".js", function (e) {
                    //                     var _indx = e.variants.findIndex(function (x) {
                    //                         return x.id == vid
                    //                     });
                    //                     var selector = "wsaio-pid-" + e.id;
                    //                     _this.find('.price .price__regular').addClass(selector);
                    //                     _this.find('.price .price__sale').addClass(selector);
                    //                     WSAIO.productDiscount({
                    //                         product_id: e.id,
                    //                         product_handle: e.handle,
                    //                         variant_id: e.variants[_indx].id,
                    //                         variant_sku: e.variants[_indx].sku,
                    //                         variant_price: e.variants[_indx].price,
                    //                         variant_compare_at_price: e.variants[_indx].compare_at_price
                    //                     });
                    //                 });
                    //             }
                    //         })
                    //         $('.list-view-item').each(function () {
                    //             var _this = $(this);
                    //             var handle = _this.find('.product-card.product-card--list a').attr('href');
                    //             var vid = _this.find('.product-card.product-card--list a').attr('href');
                    //             if (handle != undefined && handle != '#') {
                    //                 handle = handle.split("products/")[1];
                    //                 handle = handle.split("?")[0];
                    //                 vid = vid.split('variant=')[1];
                    //                 console.log(vid);
                    //                 $.getJSON("/products/" + handle + ".js", function (e) {
                    //                     var _indx = e.variants.findIndex(function (x) {
                    //                         return x.id == vid
                    //                     });
                    //                     var selector = "wsaio-pid-" + e.id;
                    //                     _this.find('.price .price__regular').addClass(selector);
                    //                     _this.find('.price .price__sale').addClass(selector);
                    //                     WSAIO.productDiscount({
                    //                         product_id: e.id,
                    //                         product_handle: e.handle,
                    //                         variant_id: e.variants[_indx].id,
                    //                         variant_sku: e.variants[_indx].sku,
                    //                         variant_price: e.variants[_indx].price,
                    //                         variant_compare_at_price: e.variants[_indx].compare_at_price
                    //                     });
                    //                 });
                    //             }
                    //         })
                    //     }
                    // }


                    // setTimeout(function () {
                    //     search_variant_discount();
                    // }, 1200);







                    //=========================== on load volume table disc ==========================
                    setTimeout(function () {
                        var Vid = $('.product-template__container [name="id"]').val();
                        selected_variant_id = Vid;
                        console.log(current_product);
                        $('.product-single__meta .product__price').addClass(current_product.id);
                        var _indx = current_product.variants.findIndex(function (x) {
                            return x.id == Vid
                        })
                        if (_indx > -1) {
                            var _price = current_product.variants[_indx].price;
                            var _sku = current_product.variants[_indx].sku;
                            var _compare = current_product.variants[_indx].compare_at_price;
                        }


                        WSAIO.productDiscount({
                            template: 'product',
                            product_id: current_product.id,
                            product_handle: current_product.handle,
                            variant_id: Vid,
                            variant_sku: _sku,
                            variant_price: _price,
                            variant_compare_at_price: _compare
                        });
                    }, 3000);
                    //===========================================================

                    //=========================== recc ==========================
                    setTimeout(function () {

                        $('.col_clct').each(function () {
                            var clctn_dta = JSON.parse($(this).attr("clct"));
                            for (var i = 0; i < clctn_dta.length; i++) {
                                WSAIO.product_in_collects.push(clctn_dta[i]);
                            }
                        });

                        if (WSAIO.template != 'search') {
                            $('.grid__item.small--one-half:not(.usf-result-item)').each(function () {
                                var _this = $(this);
                                var handle = _this.find('a').attr('href');
                                handle = handle.split("products/")[1];
                                handle = handle.split("?")[0];
                                $.getJSON("/products/" + handle + ".js", function (e) {
                                    var selector = "wsaio-pid-" + e.id;
                                    _this.find('.price.price--listing .rec').addClass(selector);
                                    WSAIO.productDiscount({
                                        product_id: e.id,
                                        product_handle: e.handle,
                                        variant_id: e.variants[0].id,
                                        variant_sku: e.variants[0].sku,
                                        variant_price: e.variants[0].price,
                                        variant_compare_at_price: e.variants[0].compare_at_price
                                    });
                                });
                            });
                        }
//                         setTimeout(function () {
//                             search_variant_discount();
//                         }, 1200);
                    }, 2000);

                    //===========================================================

                    //=========================load more ========================
                    // $('.usf-load-more').click(function () {
                    //     setTimeout(function () {
                    //         if (WSAIO.template != 'search') {
                    //             $('.grid__item.grid__item--collection-template').each(function () {
                    //                 var _this = $(this);
                    //                 var handle = _this.find('a').attr('href');
                    //                 handle = handle.split("products/")[1];
                    //                 handle = handle.split("?")[0];
                    //                 if (handle != undefined) {
                    //                     $.getJSON('/products/' + handle + '.js', function (e) {
                    //                         var current_product = e;
                    //                         var selector = "wsaio-pid-" + current_product.id;
                    //                         $(_this).find('.price__sale').addClass(selector);

                    //                         WSAIO.variantChange(variant, '', current_product)
                    //                         WSAIO.variantChange(variant, '', current_product)
                    //                         WSAIO.productDiscount({
                    //                             product_id: current_product.id,
                    //                             product_handle: current_product.handle,
                    //                             variant_id: current_product.variants[0].id,
                    //                             variant_sku: current_product.variants[0].sku,
                    //                             variant_price: current_product.variants[0].price,
                    //                             variant_compare_at_price: current_product.variants[0].compare_at_price
                    //                         });
                    //                     });
                    //                 }
                    //             });
                    //         }
                    //         setTimeout(function () {
                    //             search_variant_discount();
                    //         }, 1200);

                    //         $('.usf-sr-preview').on('click', function () {
                    //             console.log("111111")
                    //             if (WSAIO.template != 'search') {
                    //                 var handle = $(".usf-zone").find("a.usf-preview__link").attr("href");
                    //                 handle = handle.split("products/")[1];
                    //                 handle = handle.split("?")[0];
                    //                 $.getJSON("/products/" + handle + ".js", function (e) {
                    //                     var selector = "wsaio-pid-" + e.id;
                    //                     $('.usf-preview__price-wrapper.price').addClass(selector);

                    //                     WSAIO.productDiscount({
                    //                         template: 'products',
                    //                         product_id: e.id,
                    //                         product_handle: e.handle,
                    //                         variant_id: e.variants[0].id,
                    //                         variant_sku: e.variants[0].sku,
                    //                         variant_price: e.variants[0].price,
                    //                         variant_compare_at_price: e.variants[0].compare_at_price
                    //                     });
                    //                 });
                    //             }
                    //             setTimeout(function () {
                    //                 search_variant_discount();
                    //             }, 1200);
                    //         });

                    //     }, 2000);
                    // });
                    //====================================================

                    //=====================quick variat ==================
//                     $(document).on("change", ".usf-preview__option select", function () {

//                         setTimeout(function () {
//                             var Vid = $('.usf-preview [name="id"]').val();
//                             selected_variant_id = Vid;
//                             var handlee = $(".usf-zone").find("a.usf-preview__link").attr("href");

//                             if (handlee != undefined && handlee != '#') {
//                                 handlee = handlee.split('/products/')[1];
//                                 handlee = handlee.split('?')[0];

//                                 jQuery.getJSON('/products/' + handlee + '.js', function (product) {
//                                     current_product = product;

//                                     $('.usf-preview__price-wrapper.price').addClass(current_product.id);
//                                     var _indx = current_product.variants.findIndex(function (x) {
//                                         return x.id == Vid
//                                     })
//                                     if (_indx > -1) {
//                                         var _price = current_product.variants[_indx].price;
//                                         var _sku = current_product.variants[_indx].sku;
//                                         var _compare = current_product.variants[_indx].compare_at_price;
//                                     }


//                                     WSAIO.productDiscount({
//                                         template: 'product',
//                                         product_id: current_product.id,
//                                         product_handle: current_product.handle,
//                                         variant_id: Vid,
//                                         variant_sku: _sku,
//                                         variant_price: _price,
//                                         variant_compare_at_price: _compare
//                                     });
//                                 })
//                             }
//                         }, 500);

//                     });
                    //=========================================================

                    setTimeout(function () {
                        if (WSAIO.template != 'search') {
                            $('.grid__item.grid__item--collection-template:not(.usf-result-item), .list-view-item:not(.usf-result-item)').each(function () {
                                var _this = $(this);
                                var handle = _this.find('a').attr('href');
                                handle = handle.split("products/")[1];
                                handle = handle.split("?")[0];
                                $.getJSON("/products/" + handle + ".js", function (e) {
                                    var selector = "wsaio-pid-" + e.id;
                                    _this.find('.price .price__regular').addClass(selector);
                                    _this.find('.price .price__sale').addClass(selector);
                                    WSAIO.productDiscount({
                                        product_id: e.id,
                                        product_handle: e.handle,
                                        variant_id: e.variants[0].id,
                                        variant_sku: e.variants[0].sku,
                                        variant_price: e.variants[0].price,
                                        variant_compare_at_price: e.variants[0].compare_at_price
                                    });
                                });
                            });
                        }
//                         setTimeout(function () {
//                             search_variant_discount();
//                         }, 1200);
                    }, 1800);
                    //========= Quick view Button Discount ===============
//                     setTimeout(function () {
//                         $('.usf-sr-preview').on('click', function () {
//                             console.log("2222")
//                             var handle = $(".usf-zone").find("a.usf-preview__link").attr("href");
//                             handle = handle.split("products/")[1];
//                             handle = handle.split("?")[0];
//                             $.getJSON("/products/" + handle + ".js", function (e) {
//                                 var selector = "wsaio-pid-" + e.id;
//                                 $('.usf-preview__price-wrapper.price').addClass(selector);

//                                 WSAIO.productDiscount({
//                                     template: 'products',
//                                     product_id: e.id,
//                                     product_handle: e.handle,
//                                     variant_id: e.variants[0].id,
//                                     variant_sku: e.variants[0].sku,
//                                     variant_price: e.variants[0].price,
//                                     variant_compare_at_price: e.variants[0].compare_at_price
//                                 });
//                             });
//                         });
//                     }, 2500);

                    //===================================================
                    //=================  Filter Discount ============================
                    var gg = false;
                    var fff = setInterval(function () {
                        if ($('.usf-sr-more').length == 1 && gg == false) {
                            gg = true;

                            setTimeout(function () {
                                if (WSAIO.template != 'search') {
                                    $('.grid__item.grid__item--collection-template:not(.usf-result-item), .list-view-item:not(.usf-result-item)').each(function () {
                                        var _this = $(this);
                                        var handle = _this.find('a').attr('href');
                                        handle = handle.split("products/")[1];
                                        handle = handle.split("?")[0];

                                        $.getJSON("/products/" + handle + ".js", function (e) {
                                            var selector = "wsaio-pid-" + e.id;
                                            _this.find('.price .price__regular').addClass(selector);
                                            _this.find('.price .price__sale').addClass(selector);
                                            WSAIO.productDiscount({
                                                product_id: e.id,
                                                product_handle: e.handle,
                                                variant_id: e.variants[0].id,
                                                variant_sku: e.variants[0].sku,
                                                variant_price: e.variants[0].price,
                                                variant_compare_at_price: e.variants[0].compare_at_price
                                            });
                                        });
                                    });
                                }
//                                 setTimeout(function () {
//                                     search_variant_discount();
//                                 }, 1200);
                            }, 1000);
//                             $('.usf-sr-preview').on('click', function () {
//                                 console.log("333")
//                                 var handle = $(".usf-zone").find("a.usf-preview__link").attr("href");
//                                 handle = handle.split("products/")[1];
//                                 handle = handle.split("?")[0];
//                                 $.getJSON("/products/" + handle + ".js", function (e) {
//                                     var selector = "wsaio-pid-" + e.id;
//                                     $('.usf-preview__price-wrapper.price').addClass(selector);

//                                     WSAIO.productDiscount({
//                                         template: 'products',
//                                         product_id: e.id,
//                                         product_handle: e.handle,
//                                         variant_id: e.variants[0].id,
//                                         variant_sku: e.variants[0].sku,
//                                         variant_price: e.variants[0].price,
//                                         variant_compare_at_price: e.variants[0].compare_at_price
//                                     });
//                                 });
//                                 setTimeout(function () {
//                                     search_variant_discount();
//                                 }, 1200);
//                             });
//                             var handle = $(".usf-zone").find("a.usf-preview__link").attr("href");
//                             handle = handle.split("products/")[1];
//                             handle = handle.split("?")[0];
//                             $.getJSON("/products/" + handle + ".js", function (e) {
//                                 var selector = "wsaio-pid-" + e.id;
//                                 _this.find('.price .price__regular').addClass(selector);
//                                 _this.find('.price .price__sale').addClass(selector);

//                                 WSAIO.productDiscount({
//                                     template: 'products',
//                                     product_id: e.id,
//                                     product_handle: e.handle,
//                                     variant_id: e.variants[0].id,
//                                     variant_sku: e.variants[0].sku,
//                                     variant_price: e.variants[0].price,
//                                     variant_compare_at_price: e.variants[0].compare_at_price
//                                 });
//                             });


                        } else if ($('.usf-sr-more').length == 0 && gg == true) {
                            gg = false
                        }
                    }, 1);
                    //====================================================
                    //============ temaplate change Discount ===========

//                     $('.usf-btn').on('click', function () {
//                         console.log("AAAAA")
//                         if (WSAIO.template != 'search') {
//                             setTimeout(function () {
//                                 $('.grid__item.grid__item--collection-template, .list-view-item').each(function () {
//                                     var _this = $(this);
//                                     var handle = _this.find('a').attr('href');
//                                     handle = handle.split("products/")[1];
//                                     handle = handle.split("?")[0];
//                                     $.getJSON("/products/" + handle + ".js", function (e) {
//                                         var selector = "wsaio-pid-" + e.id;
//                                         _this.find('.price .price__regular').addClass(selector);
//                                         _this.find('.price .price__sale').addClass(selector);
//                                         WSAIO.productDiscount({
//                                             product_id: e.id,
//                                             product_handle: e.handle,
//                                             variant_id: e.variants[0].id,
//                                             variant_sku: e.variants[0].sku,
//                                             variant_price: e.variants[0].price,
//                                             variant_compare_at_price: e.variants[0].compare_at_price
//                                         });
//                                     });
//                                 });
//                             }, 1800);
//                         }
//                         setTimeout(function () {
//                             search_variant_discount();
//                         }, 1200);
//                     });

                    //==================================================

                    setTimeout(function () {
                        if (WSAIO.template == 'cart') {
                            WSAIO.preCheckout();
                            setTimeout(function () {
                                WSAIO.preCheckout();
                            }, 7000);
                        }
                    }, 100);


                };